import React from 'react'
import Navbar from '../../navbar/Navbar'
import Footer from '../../footer/Footer';
import CSMTabs from './CSMTabs';

function CSMMOU() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <CSMTabs />
                        </div>
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>CSM MOU 
                                </h2>
                                <div className='pt-2 submit'>
                                    <h5 class="pt-3">Memorandum of Understanding (MOU) Details</h5>
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead class="table-light">
                                                <tr>
                                                    <th scope="col">S.No</th>
                                                    <th scope="col">MOUs Signed Organization</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Purpose</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Triad Techno Services</td>
                                                    <td>05/02/2024</td>
                                                    <td>To conduct workshops, guest lectures and consultancy work, industrial visits</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>



                                <div className=''>
                                    {/* <div class="detgails-right-content mt-4">
                                        <div class="related-download bg-gray">
                                            <ul>
                                                <li>
                                                    <a href="https://admin.swec.ac.in/assetsswec/documents/csm/Csm-Syllabus-of-Minor-Degree-Program(SD-R22).pdf" target='_blank'><i class="fa-solid fa-file-pdf"></i>  Syllabus of Minor Degree Program(SD-R22)</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> */}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default CSMMOU


